export default {
    doctor: 'Doctor',
    'doctorVisits': 'Doctor visits', 
    doctors: 'Doctors',
    pharmacy: 'Pharmacy',
    pharmacies: 'Pharmacies',
    center: 'Center',
    centers: 'Centers',
    'pharmacyVisits': 'Pharmacy visits',
    centerVisits: 'Center visits',
    'medicalRep': 'Medical rep',
    'doctorName': 'Doctor name',
    'doctorHobbies': 'Doctor hobbies',
    'editDoctor': 'Edit doctor',
    'deleteDoctor': 'delete doctor',
    'centerNotes': 'Center notes',
    'pharmaceuticalForms': 'Pharmaceutical forms',
    'pillsPerBox': 'pills per box',
    'medRepPlan': 'medical.Rep plan',
    'medRepZone': 'medical.Rep zne',
    'medRepMark': 'medical.Rep mark',
    'addNewDoctor': 'Add new doctor',
}